/**
 * Optimizely Adapter
 *
 * Optimizely is an experimentation platform used for A/B testing.
 * It doesn't track traditional ecommerce events through PMW, only pixel load.
 *
 * This adapter is included for consistency but returns null for all events
 * since Optimizely tracks experiments through its own snippet once loaded.
 *
 * @since 1.59.3
 */

(function (pmw, undefined) {

	class OptimizelyAdapter {

		/**
		 * Adapt event data to Optimizely format
		 *
		 * Optimizely doesn't track ecommerce events through PMW, so this always returns null.
		 * The pixel is loaded via the pmw:load-pixels event, not through event-specific triggers.
		 *
		 * @param {object} eventData - Event-specific data (product, order, etc.)
		 * @param {string} eventName - Standardized event name
		 * @param {object} context - Event context (user, page, etc.)
		 * @returns {null} Always null - Optimizely doesn't use PMW event tracking
		 */
		adapt(eventData, eventName, context) {
			// Optimizely runs its own experimentation tracking once the snippet loads
			return null;
		}
	}

	// Register the adapter
	pmw.registerAdapter('optimizely', new OptimizelyAdapter(), {
		supportsS2S               : false,
		supportsEventDeduplication: false,
		isActive                  : () => pmwDataLayer?.pixels?.optimizely?.project_id ? true : false
	});

}(window.pmw = window.pmw || {}));
